import { Box } from '@mui/material';
import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from '../../../../components/Tabs/Tabs';
import UserDetailsDevicesTable from './UserDetailsDevicesTable';
import UserDetailsSimsTable from './UserDetailsSimsTable';
import {
  Device,
  CancelScheduledOperationRequest,
  GetDeviceByIdFn,
  GetDeviceFn,
  Sim,
  SimUpdateRequest,
} from '../../../../models/UserDevicesModels';

interface UserDetailsTabsProps {
  devices: Device[];
  sims: Sim[];
  isLoading: boolean;
  resendNotification: (deviceId: string) => void;
  isPerformingAction: boolean;
  getDeviceByDeviceId: GetDeviceByIdFn | GetDeviceFn;
  updateSimDetails: (req: SimUpdateRequest, errorCallback: () => void) => void;
  deleteDeviceHandler: (deviceId: string) => void;
  cancelScheduledOperation: (req: CancelScheduledOperationRequest) => void;
  onActionSuccess: () => void;
  assignDevice: () => void;
  addDevice: () => void;
  assignSim: () => void;
}

function UserDetailsTabs({
  devices,
  sims,
  isLoading,
  resendNotification,
  isPerformingAction,
  getDeviceByDeviceId,
  updateSimDetails,
  deleteDeviceHandler,
  cancelScheduledOperation,
  onActionSuccess,
  assignDevice,
  addDevice,
  assignSim,
}: UserDetailsTabsProps) {
  const [t] = useTranslation();
  const [tabNumber, setTabNumber] = useState(0);
  const tabs = [t('pages.userDetails.tabs.devices'), t('pages.userDetails.tabs.simCards')];

  /**
   * Sets the tab number
   * @param n
   */
  const handleTabChange = (n: number) => {
    setTabNumber(n);
  };

  return (
    <>
      <Box sx={{ width: '100%', paddingTop: '2.5rem' }}>
        <Tabs tabs={tabs} handleTabChange={handleTabChange} />
      </Box>
      {tabNumber === 0 ? (
        <Box sx={{ padding: '2rem 0' }}>
          {' '}
          <UserDetailsDevicesTable
            devices={devices}
            isLoading={isLoading}
            isPerformingAction={isPerformingAction}
            resendNotification={resendNotification}
            deleteDevice={deleteDeviceHandler}
            assignDevice={assignDevice}
            addDevice={addDevice}
          />
        </Box>
      ) : null}
      {tabNumber === 1 ? (
        <Box sx={{ padding: '2rem 0' }}>
          {' '}
          <UserDetailsSimsTable
            sims={sims}
            isLoading={isLoading}
            isPerformingAction={isPerformingAction}
            resendNotification={resendNotification}
            getDeviceById={getDeviceByDeviceId}
            onNewConnectionSuccess={onActionSuccess}
            onUpgradeSuccess={onActionSuccess}
            onSuspendSimSuccess={onActionSuccess}
            onRestoreConnectionSuccess={onActionSuccess}
            onTerminateConnectionSuccess={onActionSuccess}
            updateSim={updateSimDetails}
            cancelScheduledOperation={cancelScheduledOperation}
            assignSim={devices.length ? assignSim : undefined}
          />
        </Box>
      ) : null}
    </>
  );
}

export default memo(UserDetailsTabs);
